import { render, staticRenderFns } from "./SHSettledCardSkeleton.vue?vue&type=template&id=f201d3f4&"
import script from "./SHSettledCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SHSettledCardSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports